// Toggle this to inject the simulation round instead of real spin data
export const DEV_SIMULATION_ENABLED = false;

// ── Dev Feature Combo Override ──────────────────────────────────────────────
// Force the bonus buy to request a specific feature combination.
// Sent as `feature_combo` in the API payload alongside purchased_feature.
//
// Set via URL query param:  ?feature=MC  (or M, D, C, MD, DC, MDC)
// Or hardcode below for persistent override.
//
// Valid values (GDD order: M→D→C):
//   Single features:  "M", "D", "C"
//   Double features:  "MD", "MC", "DC"
//   All three:        "MDC"
//   Random (default): null or undefined (omits feature_combo from payload)
const _urlCombo =
  typeof window !== "undefined"
    ? new URLSearchParams(window.location.search).get("feature")
    : null;
export const DEV_FEATURE_COMBO = _urlCombo || null;

// Dev: Multiple Zeus coins for bolt sound testing
// 12=Zeus Double, 13=Zeus Mystery, 14=Zeus Collect, 15=Coin
export const DEV_SIMULATION_ROUND = {
  bet: 25,
  win: 0,
  reels: [
    [4, 3, 2], // reel 0: zeus_double, m3, zeus_collect
    [13, 4, 5], // reel 1: zeus_mystery, m4, zeus_double
    [6, 13, 5], // reel 2: zeus_collect, zeus_mystery, l1
    [3, 1, 13], // reel 3: m3, zeus_double, zeus_collect
    [13, 6, 2], // reel 4: zeus_mystery, l2, zeus_double
  ],
  wins: [],
  winType: null,
  isAnimatedWin: false,
  coinCount: 0,
  coinPositions: [],
  scatterCount: 0,
  scatterPositions: [],
  type: "regular",
  anticipation: false,
  id: `test-dev-sim-${Date.now()}`,
  storage: null,
};
